const results = [
  { icon: 'ri-route-line', text: 'Понятные цели развития сотрудников' },
  { icon: 'ri-user-settings-line', text: 'Индивидуальные траектории развития' },
  { icon: 'ri-focus-3-line', text: 'Более адресное обучение' },
  { icon: 'ri-links-line', text: 'Связь обучения с рабочими задачами' },
  { icon: 'ri-vip-crown-line', text: 'Развитие кадрового резерва' },
  { icon: 'ri-rocket-line', text: 'Подготовка сотрудников к новым ролям' },
  { icon: 'ri-user-star-line', text: 'Повышение самостоятельности сотрудников' },
  { icon: 'ri-team-line', text: 'Более системная работа руководителей с развитием команды' },
  { icon: 'ri-radar-line', text: 'Понятные критерии прогресса' },
  { icon: 'ri-file-list-3-line', text: 'Снижение формальности в развитии персонала' },
];

export default function CompanyResults() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат внедрения ИПР — это управляемое развитие, а не гарантированный рост финансовых показателей
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}